<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  created () {
    // if(this.$route.query.id == 'xmjj') {
      this.richText = '<p style="margin-bottom: 40px;text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Overview</span></p>'
        + '<div id="left" style="float:left ; width:50%; height:100%;">'
        + '<p style="margin-bottom : 20px;text-align: justify"><span style="margin-left: 0px; font-size: 16px;">National Facility for Translational Medicine(Shanghai),NFTM,is a state-of-the-art facility hosted by Shanghai Jiao Tong University. It is rooted from the 12th 5-year plan of Chinese Central Government and a part of National Health Strategy, which was approved by National Development and Reform Committee (NDRC) in 2013.</span></p>'
        + '<p style="margin-bottom : 20px;text-align: justify"><span style="margin-left: 0px; font-size: 16px;">NFTM provides users with services in several scales including core facilities, technology support & service, shared labs, research programs, international collaboration and health science popularization. </span></p>'
        + '<p style="margin-bottom : 20px;text-align: justify"><span style="margin-left: 0px; font-size: 16px;">NFTM has been operational to both domestic and foreign researchers and research groups since 2019. </span></p>'
        + '</div>'

        + '<div id="right" style="float: left; width: 50%; height: 100%;">'
        + '<p style="margin-bottom : 20px; margin-left : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/xmjj_en_1.png" alt="" ></p>'
        + '</div>'
        + '<p>&nbsp;</p><p>&nbsp;</p>'
    // }else if(this.$route.query.id == 'jsnr'){
      + '<p style="margin-bottom: 40px; text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Mission</span></p>'
        + '<div id="left" style="float:left ; width:100%; height:100%;">'
        + '<p style="margin-bottom : 20px;text-align: justify"><span style="font-size: 16px;">NFTM is committed to supporting research into areas of significant scientific concern relating to major diseases, including cancer as well as metabolic, cardiovascular, and cerebrovascular diseases. Three core systems have been established under the framework of the NFTM, including resource and information, technical support, and clinical transformation systems, with the prime aim to support scientific research and technological development in the areas of drug discovery, biomedical materials, biomedical device manufacturing, and biomedical informatics, amongst others.</span></p>'
        + '<p style="margin-bottom : 20px; margin-left : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jsnr_en_1.png" alt="" width="900px"></p>'
        + '</div>'

        + '<p>&nbsp;</p>'
        + '<p style="margin-bottom: 40px; text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Research Service & Support</span></p>'
        + '<div id="right" style="float: left; width: 100%; height: 100%;">'
        + '<p style="margin-bottom : 20px;text-align: justify"><span style="font-size: 16px;">NFTM is designed to establish a comprehensive research service & support through the integration of Core Facilities(C), Technology Centers(T) and Research Orientations(R).</span></p>'
        + '<p style="margin-bottom : 20px; margin-left : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jsnr_en_2.png" alt="" width="900px"></p>'
        + '</div>'
        + '<p>&nbsp;</p>';
    // }

},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }

.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 20px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/about/en/index.vue